import { withReceptionServiceGuard } from '~libs.shared.reception-service';

export type { ReceptionServiceFormPart } from './extensions/calendar/appointment/interactiveTable/receptionService.types';

import { ReceptionServiceInteractiveTable } from './extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable';
import { ReceptionServiceList as AppointmentReceptionServiceList } from './extensions/calendar/appointment/list/ReceptionServiceList';
import { ReceptionServiceList as SettlementReceptionServiceList } from './extensions/calendar/settlement/ReceptionServiceList';
import { translations } from './translations';
import { getCalculatedTotalEstimatedDuration } from './shared/receptionService.utils';

export default {
   calendar: {
      settlement: {
         ReceptionServiceList: withReceptionServiceGuard(SettlementReceptionServiceList, { allowReadOnly: true }),
      },
      appointment: {
         ReceptionServiceList: withReceptionServiceGuard(AppointmentReceptionServiceList),
         ReceptionServiceInteractiveTable: withReceptionServiceGuard(ReceptionServiceInteractiveTable),
      },
   },
   // Static re-exports
   translations: translations,
   getCalculatedTotalEstimatedDuration: getCalculatedTotalEstimatedDuration,
};
